/**
 * Cuentas de un puesto.
 *
 * Aparece cuando una mesa tiene más de una cuenta abierta — dos grupos que
 * comparten mesa y pagan por separado. Con una sola cuenta no se muestra: se
 * entra directo, porque ese es el 90% de los casos y un paso extra ahí sería
 * fricción pura.
 *
 * La etiqueta es lo que reemplaza a la numeración física que este restaurante
 * no tiene. "Camisa azul" identifica mejor que "Cuenta 2".
 */

import { cop, pad2 } from '../lib/formato';
import type { MesaVista } from '../datos/vistas';

interface Props {
  mesa: MesaVista;
  onElegir: (ordenId: string) => void;
  onNuevaCuenta: () => void;
  onCerrar: () => void;
}

export function ModalCuentas({ mesa, onElegir, onNuevaCuenta, onCerrar }: Props) {
  return (
    <div className="overlay on" onMouseDown={(e) => e.target === e.currentTarget && onCerrar()}>
      <div className="modal sm" role="dialog" aria-modal="true" style={{ maxWidth: 430 }}>
        <header>
          <h2>{mesa.nombre ?? `Mesa ${pad2(mesa.numero)}`}</h2>
          <span className="mono" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
            {mesa.cuentas.length} cuentas · {cop(mesa.total)}
          </span>
          <button className="close" onClick={onCerrar} aria-label="Cerrar">
            ✕
          </button>
        </header>

        <div className="body">
          <div style={{ display: 'grid', gap: 10 }}>
            {mesa.cuentas.map((c, i) => (
              <button
                key={c.orden.id}
                className="method"
                style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}
                onClick={() => onElegir(c.orden.id)}
              >
                <span className="me">{c.orden.estado === 'cuenta_solicitada' ? '🧾' : '🍽️'}</span>
                <span style={{ flex: 1, textAlign: 'left' }}>
                  <span className="mt" style={{ display: 'block' }}>
                    {c.orden.etiqueta ?? `Cuenta ${i + 1}`}
                  </span>
                  <span className="ms">
                    {c.items} ítems · {c.minutos} min ·{' '}
                    {c.orden.estado === 'cuenta_solicitada' ? 'cuenta pedida' : 'abierta'}
                  </span>
                </span>
                <span className="mono" style={{ fontWeight: 700 }}>
                  {cop(c.total)}
                </span>
              </button>
            ))}
          </div>
        </div>

        <footer>
          <button className="btn btn-ghost" onClick={onNuevaCuenta}>
            + Otra cuenta acá
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn btn-primary" onClick={onCerrar}>
            Cerrar
          </button>
        </footer>
      </div>
    </div>
  );
}
